import {
  Box, List, ListItem, ListItemText
} from '@mui/material';
import { useStyles } from './style';

// eslint-disable-next-line react/prop-types
export const AgreementBox = ({ isIndex, data, onEndOfScrollFunc = () => { } }) => {
  const classes = useStyles();

  const agreementScrollFunc = (e) => {
    if (e.target.scrollTop >= (e.target.scrollHeight - (e.target.clientHeight + 1))) {
      onEndOfScrollFunc();
    }
  };

  return (
    <Box className={classes.containerBox} onScroll={agreementScrollFunc}>
      <List sx={{ width: '100%' }} className={classes.descriptionList}>
        {/* eslint-disable-next-line react/prop-types */}
        {data && data.map((value, index) => (
          <ListItem alignItems="flex-start" key={value.id}>
            <ListItemText
              primary={`${isIndex ? (`${index + 1}.`) : ''} ${value?.primaryText} `}
              secondary={value?.secondaryText}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};
